export enum REQUEST_TYPES {
	GET_USER_INFO = 'GET_USER_INFO',
}
